<template>
  <div class="phev">
    <Head></Head>
    <div class="pc" v-if="isPhone==false">
      <div class="container">
        <div class="section1">
          <img alt="xxx" :src="data.sec1.url" style="width: 100%;" />
        </div>
        <div class="section2">
          <img alt="xxx" :src="data.sec2.bacUrl" style="width: 100%;" />
          <div class="contain">
            <div class="title">远见众行，净效千里</div>
            <div class="line"></div>
            <div class="text">{{data.sec2.text}}</div>
            <div class="nav">
              <div class="block">
                <div class="clickLeft clickStyle" @click="changeNavLeft()">
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202008/1916312200Ou.png"
                    style="width: 100%;"
                  />
                </div>
                <div
                  class="item clickStyle"
                  :id="getNavId(navItem1.index)"
                  style="margin-left:2px;"
                  @click="changeNav(navItem1.index)"
                >{{navItem1.text}}</div>
                <div
                  class="item clickStyle"
                  :id="getNavId(navItem2.index)"
                  style="margin-left:2px;"
                  @click="changeNav(navItem2.index)"
                >{{navItem2.text}}</div>
                <div
                  class="item clickStyle"
                  :id="getNavId(navItem3.index)"
                  style="margin-left:2px;"
                  @click="changeNav(navItem3.index)"
                >{{navItem3.text}}</div>
                <div
                  class="item clickStyle"
                  :id="getNavId(navItem4.index)"
                  style="margin-left:2px;"
                  @click="changeNav(navItem4.index)"
                >{{navItem4.text}}</div>
                <div
                  class="item clickStyle"
                  :id="getNavId(navItem5.index)"
                  style="margin-left:2px;"
                  @click="changeNav(navItem5.index)"
                >{{navItem5.text}}</div>
                <div
                  class="clickRight clickStyle"
                  style="margin-left:2px;"
                  @click="changeNavRight()"
                >
                  <img
                    alt="xxx"
                    src="https://www.csvw.com/u/cms/www/202008/19163450X14Q.png"
                    style="width: 100%;"
                  />
                </div>

                <div style="clear: both;"></div>
              </div>
            </div>
            <div class="content">
              <div class="left clickStyle">
                <img
                  alt="xxx"
                  :src="data.sec2.img2"
                  style="width: 100%;"
                  @click="showPop(data.sec2.img2Pop)"
                />
              </div>
              <div class="right">
                <img
                  alt="xxx"
                  :src="data.sec2.img3"
                  style="width: 100%;"
                  @click="showPop(data.sec2.img3Pop)"
                  class="clickStyle"
                />
                <img
                  alt="xxx"
                  :src="data.sec2.img4"
                  style="width: 100%;margin-top:6px;"
                  @click="showPop(data.sec2.img4Pop)"
                  class="clickStyle"
                />
              </div>
              <div style="clear: both;"></div>
            </div>
          </div>
          <div class="contain2 clickStyle">
            <div class="line1" v-if="navIndex==1">
              <img
                alt="xxx"
                src="../../assets/phev/imgs/xiyu1.png"
                style="width: 100%;"
                @click="changeNavMap(1)"
              />
            </div>
            <div class="line1" v-if="navIndex!=1">
              <img
                alt="xxx"
                src="../../assets/phev/imgs/xiyu2.png"
                style="width: 100%;"
                @click="changeNavMap(1)"
              />
            </div>
            <div class="line2" v-if="navIndex==2">
              <img
                alt="xxx"
                src="../../assets/phev/imgs/tainkong1.png"
                style="width: 100%;"
                @click="changeNavMap(2)"
              />
            </div>
            <div class="line2" v-if="navIndex!=2">
              <img
                alt="xxx"
                src="../../assets/phev/imgs/tainkong2.png"
                style="width: 100%;"
                @click="changeNavMap(2)"
              />
            </div>
            <div class="line3" v-if="navIndex==3">
              <img
                alt="xxx"
                src="../../assets/phev/imgs/huanghe1.png"
                style="width: 100%;"
                @click="changeNavMap(3)"
              />
            </div>
            <div class="line3" v-if="navIndex!=3">
              <img
                alt="xxx"
                src="../../assets/phev/imgs/huanghe2.png"
                style="width: 100%;"
                @click="changeNavMap(3)"
              />
            </div>
            <div class="line4" v-if="navIndex==4">
              <img
                alt="xxx"
                src="../../assets/phev/imgs/hongse1.png"
                style="width: 100%;"
                @click="changeNavMap(4)"
              />
            </div>
            <div class="line4" v-if="navIndex!=4">
              <img
                alt="xxx"
                src="../../assets/phev/imgs/hongse2.png"
                style="width: 100%;"
                @click="changeNavMap(4)"
              />
            </div>
            <div class="line5" v-if="navIndex==5">
              <img
                alt="xxx"
                src="../../assets/phev/imgs/qiannian1.png"
                style="width: 100%;"
                @click="changeNavMap(5)"
              />
            </div>
            <div class="line5" v-if="navIndex!=5">
              <img
                alt="xxx"
                src="../../assets/phev/imgs/qiannian2.png"
                style="width: 100%;"
                @click="changeNavMap(5)"
              />
            </div>
            <div class="line6" v-if="navIndex==6">
              <img
                alt="xxx"
                src="../../assets/phev/imgs/xinghan1.png"
                style="width: 100%;"
                @click="changeNavMap(6)"
              />
            </div>
            <div class="line6-click" v-if="navIndex!=6" @click="changeNavMap(6)"></div>
            <div class="line6" v-if="navIndex==7">
              <img
                alt="xxx"
                src="../../assets/phev/imgs/bsyw.png"
                style="width: 100%;"
                @click="changeNavMap(7)"
              />
            </div>
            <div class="line7-click" v-if="navIndex!=7" @click="changeNavMap(7)"></div>
            <div class="line6" v-if="navIndex==8">
              <img
                alt="xxx"
                src="../../assets/phev/imgs/mzfq.png"
                style="width: 100%;"
                @click="changeNavMap(8)"
              />
            </div>
            <div class="line8-click" v-if="navIndex!=8" @click="changeNavMap(8)"></div>
            <div class="line6" v-if="navIndex==9">
              <img
                alt="xxx"
                src="https://www.csvw.com/u/cms/www/202009/04120907546c.png"
                style="width: 100%;"
                @click="changeNavMap(9)"
              />
            </div>
            <div class="line9-click" v-if="navIndex!=9" @click="changeNavMap(9)"></div>
            <div class="line6" v-if="navIndex==10">
              <img
                alt="xxx"
                src="../../assets/phev/imgs/rjmj.png"
                style="width: 100%;"
                @click="changeNavMap(10)"
              />
            </div>
            <div class="line10-click" v-if="navIndex!=10" @click="changeNavMap(10)"></div>
            <div class="line11" v-if="navIndex==11">
              <img
                alt="xxx"
                src="https://www.csvw.com/u/cms/www/202009/03111053K6n7.png"
                style="width: 100%;"
                @click="changeNavMap(11)"
              />
            </div>
            <div class="line11" v-if="navIndex!=11">
              <img
                alt="xxx"
                src="https://www.csvw.com/u/cms/www/202009/031111164p73.png"
                style="width: 100%;"
                @click="changeNavMap(11)"
              />
            </div>
            <div class="line12" v-if="navIndex==12">
              <img
                alt="xxx"
                src="https://www.csvw.com/u/cms/www/202009/03111406Q3Mr.png"
                style="width: 100%;"
                @click="changeNavMap(12)"
              />
            </div>
            <div class="line12" v-if="navIndex!=12">
              <img
                alt="xxx"
                src="https://www.csvw.com/u/cms/www/202009/03111422ON41.png"
                style="width: 100%;"
                @click="changeNavMap(12)"
              />
            </div>
            <div class="line14" v-if="navIndex==14">
              <img
                alt="xxx"
                src="https://www.csvw.com/u/cms/www/202009/0311230409Qf.png"
                style="width: 100%;"
                @click="changeNavMap(14)"
              />
            </div>
            <div class="line14" v-if="navIndex!=14">
              <img
                alt="xxx"
                src="https://www.csvw.com/u/cms/www/202009/03112323UO4J.png"
                style="width: 100%;"
                @click="changeNavMap(14)"
              />
            </div>
            <div class="line13" v-if="navIndex==13">
              <img
                alt="xxx"
                src="https://www.csvw.com/u/cms/www/202009/03111445vQj6.png"
                style="width: 100%;"
                @click="changeNavMap(13)"
              />
            </div>
            <div class="line13" v-if="navIndex!=13">
              <img
                alt="xxx"
                src="https://www.csvw.com/u/cms/www/202009/03111507f5hn.png"
                style="width: 100%;"
                @click="changeNavMap(13)"
              />
            </div>
            <div class="line15" v-if="navIndex==15">
              <img
                alt="xxx"
                src="https://www.csvw.com/u/cms/www/202009/03111533B1xT.png"
                style="width: 100%;"
                @click="changeNavMap(15)"
              />
            </div>
            <div class="line15" v-if="navIndex!=15">
              <img
                alt="xxx"
                src="https://www.csvw.com/u/cms/www/202009/03111550bv98.png"
                style="width: 100%;"
                @click="changeNavMap(15)"
              />
            </div>
          </div>
        </div>
        <div class="section3">
          <img alt="xxx" :src="data.sec3.bacUrl" style="width: 100%;" />
          <div
            class="contain1"
            v-bind:class="{ 'scroll1':navIndex==1 , 'scroll2':navIndex==2 , 'scroll3':navIndex==3 , 'scroll4':navIndex==4 , 
          'scroll5':navIndex==5 , 'scroll6':navIndex==6 , 'scroll7':navIndex==7 , 'scroll8':navIndex==8 , 'scroll9':navIndex==9 , 'scroll10':navIndex==10 , 
          'scroll11':navIndex==11 ,'scroll12':navIndex==12 ,'scroll13':navIndex==13 ,'scroll14':navIndex==14 ,'scroll15':navIndex==15 , }"
          >
            <div class="wrap">
              <div class="item" v-for="(item ,i) in data.sec3.list" :key="i">
                <div class="title">{{item.title}}</div>
                <div class="text">{{item.text}}</div>
                <div class="content">
                  <div class="left" v-if="item.img1!='https://www.csvw.com'">
                    <img
                      alt="xxx"
                      :src="item.img1"
                      style="width: 100%;"
                      @click="showPop(item.img1Pop)"
                      class="clickStyle"
                    />
                  </div>
                  <div class="right" v-if="item.img2!='https://www.csvw.com'">
                    <img
                      alt="xxx"
                      :src="item.img2"
                      style="width: 100%;"
                      @click="showPop(item.img2Pop)"
                      class="clickStyle"
                    />
                  </div>
                  <div style="clear: both;"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="contain2">
            <div class="contain">
              <div v-if="videoType==0" @click="changeVideoType()" class="clickStyle">
                <img alt="xxx" :src="data.sec3.videoImg" style="width: 100%;" />
              </div>
              <div v-if="videoType==1">
                <video class="video" muted autoplay="autoplay" loop="loop" controls="controls">
                  <source :src="data.sec3.videoUrl" type="video/mp4" />
                </video>
              </div>
            </div>
          </div>
          <div class="contain3">
            <div class="contain">
              <div class="title">
                <div class="left clickStyle" id="contain3Nav1" @click="changeSec3Img(1)">
                  <div>Passat PHEV</div>
                  <div>帕萨特插电式混合动力版</div>
                </div>
                <div class="right clickStyle" id="contain3Nav2" @click="changeSec3Img(2)">
                  <div>Tiguan L PHEV</div>
                  <div>途观L插电式混合动力版</div>
                </div>
                <div style="clear: both;"></div>
              </div>
              <div style="clear: both;"></div>
              <div class="img">
                <img alt="xxx" :src="sec3Contain3Img" style="width: 100%;" />
              </div>
              <div class="text">{{sec3Contain3Text}}</div>
            </div>
          </div>
        </div>
        <div class="section4">
          <popup :showCover="showCover" :popUrl="popUrl" :dataPop="dataPop" :closePop="closePop"></popup>
        </div>
      </div>
    </div>
    <phevMobile v-if="isPhone"></phevMobile>
    <Foot></Foot>
  </div>
</template>

<script>
import phevMobile from "./phevMobile";
import Head from "../../components/header-index";
import Foot from "../../components/footer-index";
import popup from "../../components/popup/phev/popup";
import { pbev_306, pbev_308 } from "../../components/config";

import {
  data1,
  data2,
  data3,
  data4,
  data5,
  data6,
  data7,
  data8,
  data9,
  data10,
  data11,
  data12,
  data13,
  data14,
  data15,
} from "./data";
export default {
  name: "Classroom",
  components: {
    Head,
    Foot,
    phevMobile,
    popup,
  },
  data() {
    return {
      isPhone: false,
      navIndex: 1,
      navArr: [
        {
          index: 1,
          text: "传奇西域",
        },
        {
          index: 2,
          text: "天空之镜",
        },
        {
          index: 3,
          text: "黄河明珠",
        },
        {
          index: 4,
          text: "红色基地",
        },
        {
          index: 5,
          text: "千年古都",
        },
        {
          index: 6,
          text: "兴汉胜境",
        },
        {
          index: 7,
          text: "巴蜀韵味",
        },
        {
          index: 8,
          text: "民族风情",
        },
        {
          index: 9,
          text: "川西美景",
        },
        {
          index: 10,
          text: "人间秘境",
        },
        {
          index: 11,
          text: "魔幻山城",
        },
        {
          index: 12,
          text: "楚汉名城",
        },
        {
          index: 13,
          text: "英雄之城",
        },
        {
          index: 14,
          text: "荆楚风韵",
        },
        {
          index: 15,
          text: "邂逅金陵",
        },
      ],
      navItem1: "",
      navItem2: "",
      navItem3: "",
      navItem4: "",
      navItem5: "",
      videoType: 0,
      showCover: false,
      popUrl: "",
      sec3Contain3Text: "",
      sec3Contain3Text1:
        "帕萨特插电式混合动力版最大功率155kW，最大扭矩400Nm，混合动力模式百公里加速7.8s，纯电模式续航里程63km。更有多种驾驶模式解决各种用车路况需求，以先进的双擎动力科技、强劲又不失平顺的驾控体验、令人放心的安全防护，成为PHEV细分市场的破局者。",
      sec3Contain3Text2:
        "途观L插电式混合动力版承袭途观出众的产品基因背书，汇集大众领先的新能源技术，凭借卓越的混合动力系统、全方位的安全技术、大众最新智电科技及大气独特的外观设计，打造“放心使用的PHEV”，为追求品质又注重节能的消费者提供新的选择。途观L插电式混合动力版的到来填补了新能源市场合资品牌PHEV车型空缺，以市场破局者之姿，树立PHEV市场安全新标杆。",
      sec3Contain3Img: pbev_306,
      data: data1,
      dataPop: [
        {
          index: 0,
          url: "",
        },
      ], // 弹出框图片
    };
  },
  mounted: function () {
    // 判断是否手机
    this.getIsPhone();
    this.setTitle();
    if (this.isPhone == false) {
      this.init();
      this.initNav();
    }
  },
  methods: {
    getIsPhone() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          this.isPhone = true;
        }
      }
    },
    setTitle() {
      document.title = "远见众行，净效千里";
    },
    init() {
      setTimeout(() => {
        this.changeNavOnly(1);
      }, 10);
    },
    changeNavLeft() {
      if (this.navIndex > 1) {
        let type = this.navIndex - 1;
        this.autoChangeNav(type);
      }
    },
    changeNavRight() {
      if (this.navIndex < 15) {
        let type = this.navIndex + 1;
        this.autoChangeNav(type);
      }
    },
    changeNav(type) {
      this.clearNav();
      setTimeout(() => {
        this.changeNavOnly(type);
      }, 10);
    },
    changeNavMap(type) {
      this.clearNav();
      setTimeout(() => {
        this.changeNavOnly(type);
      }, 10);
      setTimeout(() => {
        this.autoChangeNav(type);
      }, 10);
    },
    changeNavOnly(type) {
      if (type == 1) {
        this.data = data1;
        document.getElementById(`nav1`).style.background = "rgba(230,126,2,1)";
      } else if (type == 2) {
        this.data = data2;
        document.getElementById(`nav2`).style.background = "rgba(53,114,171,1)";
      } else if (type == 3) {
        this.data = data3;
        document.getElementById(`nav3`).style.background = "rgba(255,205,66,1)";
      } else if (type == 4) {
        this.data = data4;
        document.getElementById(`nav4`).style.background = "rgba(238,34,0,1)";
      } else if (type == 5) {
        this.data = data5;
        document.getElementById(`nav5`).style.background = "rgba(199,90,32,1)";
      } else if (type == 6) {
        this.data = data6;
        document.getElementById(`nav6`).style.background = "rgba(22,160,94,1)";
      } else if (type == 7) {
        this.data = data7;
        document.getElementById(`nav7`).style.background = "rgba(241,117,51,1)";
      } else if (type == 8) {
        this.data = data8;
        document.getElementById(`nav8`).style.background = "rgba(82,94,74,1)";
      } else if (type == 9) {
        this.data = data9;
        document.getElementById(`nav9`).style.background = "rgba(103,126,44,1)";
      } else if (type == 10) {
        this.data = data10;
        document.getElementById(`nav10`).style.background = "rgba(23,159,93,1)";
      } else if (type == 11) {
        this.data = data11;
        document.getElementById(`nav11`).style.background = "rgba(58,82,170,1)";
      } else if (type == 12) {
        this.data = data12;
        document.getElementById(`nav12`).style.background =
          "rgba(40,148,223,1)";
      } else if (type == 13) {
        this.data = data13;
        document.getElementById(`nav13`).style.background = "rgba(254,0,0,1)";
      } else if (type == 14) {
        this.data = data14;
        document.getElementById(`nav14`).style.background = "rgba(1,123,209,1)";
      } else if (type == 15) {
        this.data = data15;
        document.getElementById(`nav15`).style.background =
          "rgba(210,174,98,1)";
      }

      this.navIndex = type;

      // 设置公共值
      this.sec3Contain3Text = this.sec3Contain3Text1;
      this.sec3Contain3Img = pbev_306;

      setTimeout(() => {
        this.changeSec3Img(1);
      }, 10);
      this.videoType = 0; // 视频给关了

      this.changeDataPop();
    },
    changeDataPop() {
      const data = [];
      const obj = {};
      const { img2Pop, img3Pop, img4Pop } = this.data.sec2;
      data.push({ index: 0, url: img2Pop });
      data.push({ index: 1, url: img3Pop });
      data.push({ index: 2, url: img4Pop });
      let inde = 2;
      const list = this.data.sec3.list;
      for (let item of list) {
        inde++;
        data.push({ index: inde, url: item.img1Pop });
        inde++;
        data.push({ index: inde, url: item.img2Pop });
      }
      this.dataPop = data;
    },
    clearNav() {
      if (document.getElementById(`nav1`)) {
        document.getElementById(`nav1`).style.background =
          "rgba(51, 51, 51, 1)";
      }
      if (document.getElementById(`nav2`)) {
        document.getElementById(`nav2`).style.background =
          "rgba(51, 51, 51, 1)";
      }
      if (document.getElementById(`nav3`)) {
        document.getElementById(`nav3`).style.background =
          "rgba(51, 51, 51, 1)";
      }
      if (document.getElementById(`nav4`)) {
        document.getElementById(`nav4`).style.background =
          "rgba(51, 51, 51, 1)";
      }
      if (document.getElementById(`nav5`)) {
        document.getElementById(`nav5`).style.background =
          "rgba(51, 51, 51, 1)";
      }
      if (document.getElementById(`nav6`)) {
        document.getElementById(`nav6`).style.background =
          "rgba(51, 51, 51, 1)";
      }
      if (document.getElementById(`nav7`)) {
        document.getElementById(`nav7`).style.background =
          "rgba(51, 51, 51, 1)";
      }
      if (document.getElementById(`nav8`)) {
        document.getElementById(`nav8`).style.background =
          "rgba(51, 51, 51, 1)";
      }
      if (document.getElementById(`nav9`)) {
        document.getElementById(`nav9`).style.background =
          "rgba(51, 51, 51, 1)";
      }
      if (document.getElementById(`nav10`)) {
        document.getElementById(`nav10`).style.background =
          "rgba(51, 51, 51, 1)";
      }
      if (document.getElementById(`nav11`)) {
        document.getElementById(`nav11`).style.background =
          "rgba(51, 51, 51, 1)";
      }
      if (document.getElementById(`nav12`)) {
        document.getElementById(`nav12`).style.background =
          "rgba(51, 51, 51, 1)";
      }
      if (document.getElementById(`nav13`)) {
        document.getElementById(`nav13`).style.background =
          "rgba(51, 51, 51, 1)";
      }
      if (document.getElementById(`nav14`)) {
        document.getElementById(`nav14`).style.background =
          "rgba(51, 51, 51, 1)";
      }
      if (document.getElementById(`nav15`)) {
        document.getElementById(`nav15`).style.background =
          "rgba(51, 51, 51, 1)";
      }
    },
    changeVideoType() {
      this.videoType = 1;
    },
    changeSec3Img(index) {
      console.log(index, 22);
      if (index == 1) {
        this.sec3Contain3Text = this.sec3Contain3Text1;
        this.sec3Contain3Img = pbev_306;

        if (this.navIndex == 1) {
          document.getElementById(`contain3Nav1`).style.background =
            "rgba(230,126,2,1)";
        } else if (this.navIndex == 2) {
          document.getElementById(`contain3Nav1`).style.background =
            "rgba(53,114,171,1)";
        } else if (this.navIndex == 3) {
          document.getElementById(`contain3Nav1`).style.background =
            "rgba(255,205,66,1)";
        } else if (this.navIndex == 4) {
          document.getElementById(`contain3Nav1`).style.background =
            "rgba(238,34,0,1)";
        } else if (this.navIndex == 5) {
          document.getElementById(`contain3Nav1`).style.background =
            "rgba(199,90,32,1)";
        } else if (this.navIndex == 6) {
          document.getElementById(`contain3Nav1`).style.background =
            "rgba(22, 160, 93, 1)";
        } else if (this.navIndex == 7) {
          document.getElementById(`contain3Nav1`).style.background =
            "rgba(241,117,51, 1)";
        } else if (this.navIndex == 8) {
          document.getElementById(`contain3Nav1`).style.background =
            "rgba(82,94,74, 1)";
        } else if (this.navIndex == 9) {
          document.getElementById(`contain3Nav1`).style.background =
            "rgba(103,126,44, 1)";
        } else if (this.navIndex == 10) {
          document.getElementById(`contain3Nav1`).style.background =
            "rgba(23,159,93, 1)";
        } else if (this.navIndex == 11) {
          document.getElementById(`contain3Nav1`).style.background =
            "rgba(58,82,170, 1)";
        } else if (this.navIndex == 12) {
          document.getElementById(`contain3Nav1`).style.background =
            "rgba(40,148,223, 1)";
        } else if (this.navIndex == 13) {
          document.getElementById(`contain3Nav1`).style.background =
            "rgba(254,0,0, 1)";
        } else if (this.navIndex == 14) {
          document.getElementById(`contain3Nav1`).style.background =
            "rgba(1,123,209, 1)";
        } else if (this.navIndex == 15) {
          document.getElementById(`contain3Nav1`).style.background =
            "rgba(210,174,98, 1)";
        }

        document.getElementById(`contain3Nav2`).style.background =
          "rgba(51, 51, 51, 1)";
      } else if (index == 2) {
        this.sec3Contain3Text = this.sec3Contain3Text2;
        this.sec3Contain3Img = pbev_308;

        if (this.navIndex == 1) {
          document.getElementById(`contain3Nav2`).style.background =
            "rgba(230,126,2,1)";
        } else if (this.navIndex == 2) {
          document.getElementById(`contain3Nav2`).style.background =
            "rgba(53,114,171,1)";
        } else if (this.navIndex == 3) {
          document.getElementById(`contain3Nav2`).style.background =
            "rgba(255,205,66,1)";
        } else if (this.navIndex == 4) {
          document.getElementById(`contain3Nav2`).style.background =
            "rgba(238,34,0,1)";
        } else if (this.navIndex == 5) {
          document.getElementById(`contain3Nav2`).style.background =
            "rgba(199,90,32,1)";
        } else if (this.navIndex == 6) {
          document.getElementById(`contain3Nav2`).style.background =
            "rgba(22, 160, 93, 1)";
        } else if (this.navIndex == 7) {
          document.getElementById(`contain3Nav2`).style.background =
            "rgba(241,117,51, 1)";
        } else if (this.navIndex == 8) {
          document.getElementById(`contain3Nav2`).style.background =
            "rgba(82,94,74, 1)";
        } else if (this.navIndex == 9) {
          document.getElementById(`contain3Nav2`).style.background =
            "rgba(103,126,44, 1)";
        } else if (this.navIndex == 10) {
          document.getElementById(`contain3Nav2`).style.background =
            "rgba(23,159,93, 1)";
        } else if (this.navIndex == 11) {
          document.getElementById(`contain3Nav2`).style.background =
            "rgba(58,82,170, 1)";
        } else if (this.navIndex == 12) {
          document.getElementById(`contain3Nav2`).style.background =
            "rgba(40,148,223, 1)";
        } else if (this.navIndex == 13) {
          document.getElementById(`contain3Nav2`).style.background =
            "rgba(254,0,0, 1)";
        } else if (this.navIndex == 14) {
          document.getElementById(`contain3Nav2`).style.background =
            "rgba(1,123,209, 1)";
        } else if (this.navIndex == 15) {
          document.getElementById(`contain3Nav2`).style.background =
            "rgba(210,174,98, 1)";
        }

        document.getElementById(`contain3Nav1`).style.background =
          "rgba(51, 51, 51, 1)";
      }
    },
    showPop(url) {
      this.showCover = true;
      this.popUrl = url;
    },
    closePop() {
      this.showCover = false;
    },
    initNav() {
      // setInterval(() => {
      //   if (this.navIndex < 10) {
      //     this.changeNav(this.navIndex + 1);
      //   } else {
      //     this.changeNav(1);
      //   }
      // }, 8000);

      this.navItem1 = this.navArr[0];
      this.navItem2 = this.navArr[1];
      this.navItem3 = this.navArr[2];
      this.navItem4 = this.navArr[3];
      this.navItem5 = this.navArr[4];
    },
    autoChangeNav(index) {
      if (index >= 1 && index <= 5) {
        this.navItem1 = this.navArr[0];
        this.navItem2 = this.navArr[1];
        this.navItem3 = this.navArr[2];
        this.navItem4 = this.navArr[3];
        this.navItem5 = this.navArr[4];
      } else if (index >= 6 && index <= 10) {
        this.navItem1 = this.navArr[5];
        this.navItem2 = this.navArr[6];
        this.navItem3 = this.navArr[7];
        this.navItem4 = this.navArr[8];
        this.navItem5 = this.navArr[9];
      } else if (index >= 11) {
        this.navItem1 = this.navArr[10];
        this.navItem2 = this.navArr[11];
        this.navItem3 = this.navArr[12];
        this.navItem4 = this.navArr[13];
        this.navItem5 = this.navArr[14];
      }

      this.changeNav(index);
    },
    getNavId(index) {
      return `nav${index}`;
    },
  },
};
</script>

<style scoped>
.phev {
  position: relative;
}
img {
  display: block;
}
.clickStyle {
  cursor: pointer;
}
@media screen and (min-width: 1px) {
  .container {
    position: relative;
    width: 1880px;
    margin: auto;
  }
  .section1 {
    position: relative;
  }
  .section2 {
    position: relative;
  }
  .section2 .contain {
    position: absolute;
    top: 0px;
    left: 920px;
    width: 695px;
  }
  .section2 .contain .title {
    font-size: 36px;
    color: rgba(34, 34, 34, 1);
    line-height: 81px;
  }
  .section2 .contain .line {
    background: rgba(0, 0, 0, 1);
    border: 1px solid rgba(49, 49, 49, 1);

    margin-top: 5px;
  }
  .section2 .contain .text {
    font-size: 16px;
    color: rgba(34, 34, 34, 1);
    line-height: 25px;
    height: 90px;
    overflow-y: auto;

    margin-top: 15px;
  }
  .section2 .contain .nav {
    position: relative;
    margin-top: 5px;
  }
  .section2 .contain .nav .clickLeft {
    position: relative;
    float: left;
    width: 30px;
    height: 46px;
  }
  .section2 .contain .nav .clickRight {
    position: relative;
    float: left;
    width: 30px;
    height: 46px;
  }
  .section2 .contain .nav .item {
    position: relative;
    float: left;
    height: 46px;
    width: 124px;
    background: rgba(51, 51, 51, 1);

    font-size: 21px;
    color: rgba(255, 255, 255, 1);
    line-height: 46px;
    text-align: center;
  }
  .section2 .contain .content {
    position: relative;
    margin-top: 15px;
  }
  .section2 .contain .content .left {
    position: relative;
    float: left;
    width: 384px;
  }
  .section2 .contain .content .right {
    position: relative;
    float: right;
    width: 302px;
  }
  .section2 .contain2 .line1 {
    position: absolute;
    top: 219px;
    left: 314px;
    width: 177px;
  }
  .section2 .contain2 .line2 {
    position: absolute;
    top: 317px;
    left: 446px;
    width: 50px;
  }
  .section2 .contain2 .line3 {
    position: absolute;
    top: 326px;
    left: 493px;
    width: 54px;
  }
  .section2 .contain2 .line4 {
    position: absolute;
    top: 325px;
    left: 543px;
    width: 67px;
  }
  .section2 .contain2 .line5 {
    position: absolute;
    top: 361px;
    left: 558px;
    width: 48px;
  }
  .section2 .contain2 .line6 {
    position: absolute;
    top: 391px;
    left: 460px;
    width: 130px;
  }
  .section2 .contain2 .line6-click {
    position: absolute;
    top: 394px;
    left: 525px;
    width: 35px;
    height: 25px;
    z-index: 100;
  }

  .section2 .contain2 .line7-click {
    position: absolute;
    width: 30px;
    height: 20px;
    top: 422px;
    left: 485px;
    z-index: 100;
  }
  .section2 .contain2 .line8-click {
    position: absolute;
    width: 35px;
    height: 15px;
    top: 442px;
    left: 460px;
    z-index: 100;
  }
  .section2 .contain2 .line9-click {
    position: absolute;
    width: 20px;
    height: 12px;
    top: 448px;
    left: 497px;
    z-index: 100;
  }
  .section2 .contain2 .line10-click {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 452px;
    left: 514px;
    z-index: 100;
  }
  .section2 .contain2 .line11 {
    position: absolute;
    top: 432px;
    left: 528px;
    z-index: 10;
  }
  .section2 .contain2 .line12 {
    position: absolute;
    top: 459px;
    left: 587px;
    z-index: 10;
  }
  .section2 .contain2 .line14 {
    position: absolute;
    top: 412px;
    left: 640px;
    z-index: 10;
  }
  .section2 .contain2 .line13 {
    position: absolute;
    top: 445px;
    left: 654px;
    z-index: 10;
  }
  .section2 .contain2 .line15 {
    position: absolute;
    top: 387px;
    left: 688px;
    z-index: 10;
  }

  .section3 {
    position: relative;
  }
  .section3 .contain1 {
    position: absolute;
    top: 66px;
    left: 280px;
    width: 620px;
    height: 700px;
    margin-top: 20px;
    overflow-y: auto;
  }
  .section3 .contain1::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  .section3 .scroll1::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(230, 126, 2, 1);
    background: #535353;
  }
  .section3 .scroll2::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(53, 114, 171, 1);
    background: #535353;
  }
  .section3 .scroll3::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(255, 205, 66, 1);
    background: #535353;
  }
  .section3 .scroll4::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(238, 34, 0, 1);
    background: #535353;
  }
  .section3 .scroll5::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(199, 90, 32, 1);
    background: #535353;
  }
  .section3 .scroll6::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(22, 160, 93, 1);
    background: #535353;
  }
  .section3 .scroll7::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(244, 188, 51, 1);
    background: #535353;
  }
  .section3 .scroll8::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(82, 94, 74, 1);
    background: #535353;
  }
  .section3 .scroll9::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(103, 126, 44, 1);
    background: #535353;
  }
  .section3 .scroll10::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(23, 159, 93, 1);
    background: #535353;
  }
  .section3 .scroll11::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(58, 82, 170, 1);
    background: #535353;
  }
  .section3 .scroll12::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(40, 148, 223, 1);
    background: #535353;
  }
  .section3 .scroll13::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(1, 123, 209, 1);
    background: #535353;
  }
  .section3 .scroll14::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(254, 0, 0, 1);
    background: #535353;
  }
  .section3 .scroll15::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(210, 174, 98, 1);
    background: #535353;
  }

  .section3 .contain1::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background: #ededed;
  }

  .section3 .contain1 .wrap {
    width: 100%;
  }
  .section3 .contain1 .wrap .item {
    position: relative;
    width: 596px;
    margin-bottom: 20px;
  }
  .section3 .contain1 .wrap .item .title {
    font-size: 30px;
    color: rgba(34, 34, 34, 1);
    line-height: 60px;
  }
  .section3 .contain1 .wrap .item .text {
    font-size: 18px;
    color: rgba(34, 34, 34, 1);
    line-height: 30px;
  }
  .section3 .contain1 .wrap .item .content {
    position: relative;
    margin-top: 20px;
  }
  .section3 .contain1 .wrap .item .left {
    position: relative;
    float: left;
  }
  .section3 .contain1 .wrap .item .right {
    position: relative;
    float: right;
  }
  .section3 .contain2 {
    position: absolute;
    top: 109px;
    left: 984px;
    width: 530px;
  }
  .section3 .contain2 .video {
    width: 100%;
  }
  .section3 .contain3 {
    position: absolute;
    top: 960px;
    left: 1050px;
    width: 547px;
    height: 304px;
  }
  .section3 .contain3 .contain {
    position: relative;
  }
  .section3 .contain3 .contain .title {
    position: relative;
    float: right;
    font-size: 16px;
    line-height: 25px;
  }
  .section3 .contain3 .contain .left {
    position: relative;
    background: rgba(22, 160, 93, 1);
    color: rgba(255, 255, 255, 1);
    width: 200px;
    padding: 5px 10px;
    float: left;
  }
  .section3 .contain3 .contain .right {
    position: relative;
    background: rgba(51, 51, 51, 1);
    color: rgba(255, 255, 255, 1);
    width: 200px;
    padding: 5px 10px;
    margin-left: 5px;
    float: left;
  }
  .section3 .contain3 .contain .img {
    margin-top: 50px;
  }
  .section3 .contain3 .contain .text {
    margin-top: 30px;

    font-size: 18px;
    color: rgba(34, 34, 34, 1);
    line-height: 30px;
  }
}

@media screen and (min-width: 1px) and (max-width: 1300px) {
  .container {
    position: relative;
    width: 1260px;
    margin: auto;
  }

  .section1 {
    position: relative;
  }
  .section2 {
    position: relative;
  }
  .section2 .contain {
    position: absolute;
    top: -10px;
    left: 610px;
    width: 475px;
  }
  .section2 .contain .title {
    font-size: 24px;
    color: rgba(34, 34, 34, 1);
    line-height: 56px;
  }
  .section2 .contain .line {
    background: rgba(0, 0, 0, 1);
    border: 1px solid rgba(49, 49, 49, 1);

    margin-top: 5px;
  }
  .section2 .contain .text {
    font-size: 11px;
    color: rgba(34, 34, 34, 1);
    line-height: 18px;
    height: 60px;

    margin-top: 5px;
  }
  .section2 .contain .nav {
    position: relative;
    margin-top: 0px;
  }
  .section2 .contain .nav .clickLeft {
    position: relative;
    float: left;
    width: 20px;
    height: 31px;
  }
  .section2 .contain .nav .clickRight {
    position: relative;
    float: left;
    width: 20px;
    height: 31px;
  }
  .section2 .contain .nav .item {
    position: relative;
    float: left;
    height: 31px;
    width: 83px;
    background: rgba(51, 51, 51, 1);

    font-size: 14px;
    color: rgba(255, 255, 255, 1);
    line-height: 31px;
    text-align: center;
  }
  .section2 .contain .content {
    position: relative;
    margin-top: 11px;
  }
  .section2 .contain .content .left {
    position: relative;
    float: left;
    width: 260px;
  }
  .section2 .contain .content .right {
    position: relative;
    float: right;
    width: 204px;
    margin-right: 4px;
  }

  .section2 .contain2 .line1 {
    position: absolute;
    top: 147px;
    left: 211px;
    width: 118px;
  }
  .section2 .contain2 .line2 {
    position: absolute;
    top: 213px;
    left: 300px;
    width: 31px;
  }
  .section2 .contain2 .line3 {
    position: absolute;
    top: 218px;
    left: 330px;
    width: 37px;
  }
  .section2 .contain2 .line4 {
    position: absolute;
    top: 217px;
    left: 365px;
    width: 43px;
  }
  .section2 .contain2 .line5 {
    position: absolute;
    top: 242px;
    left: 375px;
    width: 31px;
  }
  .section2 .contain2 .line6 {
    position: absolute;
    top: 263px;
    left: 310px;
    width: 84px;
  }
  .section2 .contain2 .line6-click {
    position: absolute;
    top: 260px;
    left: 345px;
    width: 25px;
    height: 13px;
    z-index: 100;
  }

  .section2 .contain2 .line7-click {
    position: absolute;
    top: 277px;
    left: 322px;
    width: 28px;
    height: 15px;
    z-index: 100;
  }
  .section2 .contain2 .line8-click {
    position: absolute;
    top: 291px;
    left: 315px;
    width: 20px;
    height: 10px;
    z-index: 100;
  }
  .section2 .contain2 .line9-click {
    position: absolute;
    top: 299px;
    left: 332px;
    width: 10px;
    height: 15px;
    z-index: 100;
  }
  .section2 .contain2 .line10-click {
    position: absolute;
    top: 298px;
    left: 345px;
    width: 12px;
    height: 15px;
    z-index: 100;
  }
  .section2 .contain2 .line11 {
    position: absolute;
    top: 290px;
    left: 354px;
    width: 41px;
    z-index: 10;
  }
  .section2 .contain2 .line12 {
    position: absolute;
    top: 309px;
    left: 396px;
    width: 42px;
    z-index: 10;
  }
  .section2 .contain2 .line13 {
    position: absolute;
    top: 300px;
    left: 439px;
    width: 18px;
    z-index: 10;
  }
  .section2 .contain2 .line14 {
    position: absolute;
    top: 276px;
    left: 429px;
    width: 37px;
    z-index: 10;
  }
  .section2 .contain2 .line15 {
    position: absolute;
    top: 260px;
    left: 461px;
    width: 64px;
    z-index: 10;
  }

  .section3 {
    position: relative;
  }
  .section3 .contain1 {
    position: absolute;
    top: 40px;
    left: 187px;
    width: 420px;
    height: 470px;
    margin-top: 20px;
    overflow-y: auto;
  }

  .section3 .contain1 .wrap {
    width: 100%;
  }
  .section3 .contain1 .wrap .item {
    position: relative;
    width: 400px;
    margin-bottom: 5px;
  }
  .section3 .contain1 .wrap .item .title {
    font-size: 18px;
    color: rgba(34, 34, 34, 1);
    line-height: 36px;
  }
  .section3 .contain1 .wrap .item .text {
    font-size: 12px;
    color: rgba(34, 34, 34, 1);
    line-height: 20px;
  }
  .section3 .contain1 .wrap .item .content {
    position: relative;
    margin-top: 15px;
  }
  .section3 .contain1 .wrap .item .left {
    position: relative;
    float: left;
    width: 196px;
  }
  .section3 .contain1 .wrap .item .right {
    position: relative;
    float: right;
    width: 196px;
  }
  .section3 .contain2 {
    position: absolute;
    top: 74px;
    left: 665px;
    width: 353px;
  }
  .section3 .contain2 .video {
    width: 100%;
  }
  .section3 .contain3 {
    position: absolute;
    top: 640px;
    left: 668px;
    width: 402px;
    height: 304px;
  }
  .section3 .contain3 .contain {
    position: relative;
  }
  .section3 .contain3 .contain .title {
    position: relative;
    float: right;
    font-size: 11px;
    line-height: 15px;
  }
  .section3 .contain3 .contain .left {
    position: relative;
    background: rgba(22, 160, 93, 1);
    color: rgba(255, 255, 255, 1);
    width: 145px;
    padding: 3px 5px;
    float: left;
  }
  .section3 .contain3 .contain .right {
    position: relative;
    background: rgba(51, 51, 51, 1);
    color: rgba(255, 255, 255, 1);
    width: 145px;
    padding: 3px 5px;
    margin-left: 5px;
    float: left;
  }
  .section3 .contain3 .contain .img {
    margin-top: 15px;
  }
  .section3 .contain3 .contain .text {
    margin-top: 10px;

    font-size: 12px;
    color: rgba(34, 34, 34, 1);
    line-height: 20px;
  }
}

@media screen and (min-width: 1301px) and (max-width: 1600px) {
}
</style>